import BannerComp from "../components/BannerComp";
import Seo from "../components/Seo";
import { SpecialCardSection } from "../components/SpecialCard";
import { specialties } from "../data/specialties";
import { createBreadcrumbSchema } from "../lib/seo";

const seo = {
  title: "Specialized Billing Support For Diverse Medical Practices",
  description:
    "Explore the specialties we support with tailored workflows, accurate coding support, and revenue cycle solutions designed for clinical and operational efficiency.",
  keywords:
    "medical specialties billing, specialty medical billing, healthcare specialty support",
  schema: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Healthcare Specialties Revenue Cycle Management",
      url: "https://psprcm.us/specialities/",
      description:
        "Explore the specialties we support with tailored workflows, accurate coding support, and revenue cycle solutions designed for clinical and operational efficiency.",
      serviceType: "Revenue Cycle Management for Healthcare Specialties",
      provider: {
        "@type": "Organization",
        name: "Physicians Success Partners",
        url: "https://psprcm.us/",
        logo: "https://psprcm.us/logo/main-logo.webp",
        telephone: "+1 6155536787",
        email: "info@psprcm.us",
        address: {
          "@type": "PostalAddress",
          streetAddress: "1616 Westgate Circle",
          addressLocality: "Brentwood",
          addressRegion: "TN",
          postalCode: "37027",
          addressCountry: "USA",
        },
      },
      areaServed: {
        "@type": "Country",
        name: "United States",
      },
      audience: {
        "@type": "MedicalAudience",
        audienceType: "Healthcare Providers",
      },
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "RCM Services by Healthcare Specialties",
        itemListElement: [
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Primary Care Billing" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Cardiology Billing" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Dermatology Billing" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Orthopedic Billing" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Neurology Billing" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "OB/GYN Billing" } },
        ],
      },
    },
    createBreadcrumbSchema("/specialities", "Specialized Billing Support For Diverse Medical Practices"),
  ],
};

export default function Specialities() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath="/specialities"
        schema={seo.schema}
      />
      <BannerComp
        heading="Specialized Billing Support For Diverse Medical Practices"
        paragraph="Explore the specialties we support with tailored workflows, accurate coding support, and revenue cycle solutions designed for clinical and operational efficiency."
        form={false}
        centered
      />

      <SpecialCardSection
        items={specialties}
        variant="card"
        eyebrow="Our Specialities"
        heading="Focused support across the specialties healthcare teams depend on every day."
        description="We work with a broad range of medical specialties and shape our support around the unique billing, documentation, and reimbursement needs of each practice type."
      />
    </>
  );
}
